module.exports = __webpack_public_path__ + "media/images/navbar/dropdown_menu/resources-a8285b3267192c094b77245855765884.svg";